import { gql } from '@apollo/client';
export const templateNameQuery = gql `
  query templateName($id: UUID!) {
    template(id: $id) {
      id

      composerTemplates {
        id
        composer {
          id
          metadata {
            name
            marketLocaleCode
          }
        }
      }
    }
  }
`;
